import React from 'react';

const ThreeDimensionalIcon = ({
  stroke = '#000000',
  ...props
}: {
  stroke?: string;
}) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="63"
      height="63"
      rx="7.5"
      fill="white"
      stroke={stroke === '#6930CA' ? stroke : '#A6A7B0'}
    />
    <rect
      x="25.2441"
      y="11.6409"
      width="31"
      height="31"
      rx="3.5"
      transform="rotate(20 25.2441 11.6409)"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <rect
      x="28.7871"
      y="20.9116"
      width="15"
      height="13"
      rx="1"
      transform="rotate(20 28.7871 20.9116)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="31.5195"
      y="25.0991"
      width="15"
      height="13"
      rx="1"
      transform="rotate(20 31.5195 25.0991)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <circle
      cx="40.1074"
      cy="34.3435"
      r="1.5"
      transform="rotate(20 40.1074 34.3435)"
      fill={stroke}
    />
    <path
      d="M29.7277 21.254C28.3254 21.9658 27.6283 24.0518 33.416 25.7393"
      stroke={stroke}
      strokeWidth="2"
    />
    <path
      d="M24.7403 32.2081C24.2272 33.6177 22.3466 36.0193 27.7457 37.5587"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="26.3105"
      y="29.8545"
      width="2"
      height="3"
      transform="rotate(20 26.3105 29.8545)"
      fill="#F4F6F9"
    />
    <path
      d="M24.2404 33.4056L27.0779 25.6096C27.2668 25.0906 27.8406 24.823 28.3596 25.0119L29.2993 25.354C29.8183 25.5429 30.0859 26.1167 29.897 26.6357L26.8188 35.0929C26.6299 35.6119 26.0558 35.8639 25.6197 35.525C25.1633 35.1701 24.7238 34.7162 24.3987 34.3408C24.176 34.0836 24.124 33.7253 24.2404 33.4056Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="16.4271"
      y="15.0441"
      width="31"
      height="31"
      rx="3.5"
      transform="rotate(10 16.4271 15.0441)"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <rect
      x="21.526"
      y="23.5588"
      width="15"
      height="13"
      rx="1"
      transform="rotate(10 21.526 23.5588)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="24.944"
      y="27.2083"
      width="15"
      height="13"
      rx="1"
      transform="rotate(10 24.944 27.2083)"
      fill="#F4F6F9"
      stroke={stroke}
      strokeWidth="2"
    />
    <circle
      cx="35.0078"
      cy="34.8207"
      r="1.5"
      transform="rotate(10 35.0078 34.8207)"
      fill={stroke}
    />
    <path
      d="M22.5114 23.7329C21.254 24.6774 20.9297 26.8528 26.9226 27.5096"
      stroke={stroke}
      strokeWidth="2"
    />
    <path
      d="M19.5008 35.3874C19.2403 36.8646 17.8053 39.5563 23.3897 40.1349"
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="20.6406"
      y="32.7959"
      width="2"
      height="3"
      transform="rotate(10 20.6406 32.7959)"
      fill="#F4F6F9"
    />
    <path
      d="M19.2177 36.6532L20.6584 28.4829C20.7543 27.939 21.2729 27.5758 21.8168 27.6717L22.8016 27.8453C23.3455 27.9412 23.7087 28.4599 23.6128 29.0038L22.05 37.8671C21.9541 38.411 21.4324 38.7589 20.9442 38.5008C20.433 38.2306 19.9213 37.8599 19.536 37.5466C19.272 37.3321 19.1587 36.9882 19.2177 36.6532Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="2"
    />
    <rect
      x="8.5"
      y="19.5"
      width="31"
      height="31"
      rx="3.5"
      fill="#F4F6F9"
      stroke="#E6E9EE"
    />
    <path
      d="M17.53 30.44L17.05 30.8V31.4V41.8806L14.2 40.1706V30.9369L22.5898 24.4115L24.3767 25.305L17.53 30.44Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M17.1992 31.4004L33.9992 31.4004"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M23.5 31.4004V44.0004M29.8 31.4004V44.0004"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M21.2561 23.9286L13.9265 29.6294C13.3419 30.0841 13 30.7832 13 31.5238V39.4911C13 40.3342 13.4423 41.1154 14.1652 41.5491L17.68 43.658C18.053 43.8818 18.4798 44 18.9148 44H32.65C33.9755 44 35.05 42.9255 35.05 41.6V32.6C35.05 31.8446 34.6943 31.1333 34.09 30.68L26.8231 25.2298C26.7079 25.1435 26.5852 25.0676 26.4564 25.0032L23.8028 23.6764C22.9762 23.2631 21.9856 23.3612 21.2561 23.9286Z"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default ThreeDimensionalIcon;
